/* eslint-disable */
import React, { useEffect, useState, useReducer ,useCallback} from "react";
// localizations
import { withTranslation, useTranslation, Trans } from "react-i18next";
import "./applePayButton.scss"
// redux
import { ApplePayButton } from "react-apple-pay-button";


// import { buttonVariants } from "@/components/ui/button";
import { Button } from "@material-ui/core";





function ApplePayBtn(props:any) {
  const { t } = useTranslation();


  const {handlCheckoutWithApplePay} = props;
  return (
    <React.Fragment>
      <ApplePayButton 
      id="applePayButtonl1"
       //className="py-2"
        onClick={handlCheckoutWithApplePay}
         >
     <span className="px-2">{t("checkOut.pay-with-apple")}</span> 
    </ApplePayButton>

    {/* <Button
          id="applePayButtonl1"
          className="py-2 w-100 bg-dark text-white"
           onClick={handlCheckoutWithApplePay}
    >
    <span className="px-2">PAY WITH APPLE</span> 
    </Button> */}
  

    </React.Fragment>


  );
}



export default withTranslation()(ApplePayBtn);